// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 4ZvwFlOA8Z
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Textarea from "../../Textarea"; // plasmic-import: cNeMUeiwPB/component
import Button from "../../Button"; // plasmic-import: aLOScdJViiG/component
import DrivePlugin from "../../DrivePlugin"; // plasmic-import: 3Lirqv7FAD/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicNoteViewer.module.css"; // plasmic-import: 4ZvwFlOA8Z/css

import FastArrowDownSvgrepoComsvgIcon from "./icons/PlasmicIcon__FastArrowDownSvgrepoComsvg"; // plasmic-import: YkGP0czzLn/icon
import DownloadSvgrepoComsvgIcon from "./icons/PlasmicIcon__DownloadSvgrepoComsvg"; // plasmic-import: 3dZIuViZif/icon
import CopySvgrepoComsvgIcon from "./icons/PlasmicIcon__CopySvgrepoComsvg"; // plasmic-import: TaK1a7VmsO/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: tWUxgGBbs9p/icon
import image2EMd0CwY from "./images/image2.png"; // plasmic-import: -e-MD0cwY/picture

export type PlasmicNoteViewer__VariantMembers = {
  justView: "justView";
  notionIntegration: "notionIntegration";
  googleDriveIntegration: "googleDriveIntegration";
};

export type PlasmicNoteViewer__VariantsArgs = {
  justView?: SingleBooleanChoiceArg<"justView">;
  notionIntegration?: SingleBooleanChoiceArg<"notionIntegration">;
  googleDriveIntegration?: SingleBooleanChoiceArg<"googleDriveIntegration">;
};

type VariantPropType = keyof PlasmicNoteViewer__VariantsArgs;
export const PlasmicNoteViewer__VariantProps = new Array<VariantPropType>(
  "justView",
  "notionIntegration",
  "googleDriveIntegration"
);

export type PlasmicNoteViewer__ArgsType = {};
type ArgPropType = keyof PlasmicNoteViewer__ArgsType;
export const PlasmicNoteViewer__ArgProps = new Array<ArgPropType>();

export type PlasmicNoteViewer__OverridesType = {
  root?: p.Flex<"div">;
  closeHandle?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  noteLink?: p.Flex<typeof Textarea>;
  downloadButton?: p.Flex<"svg">;
  copyNoteLink?: p.Flex<"svg">;
  columns?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  notionButton?: p.Flex<typeof Button>;
  editor?: p.Flex<"div">;
  drivePlugin?: p.Flex<typeof DrivePlugin>;
  deleteButton?: p.Flex<typeof Button>;
};

export interface DefaultNoteViewerProps {
  justView?: SingleBooleanChoiceArg<"justView">;
  notionIntegration?: SingleBooleanChoiceArg<"notionIntegration">;
  googleDriveIntegration?: SingleBooleanChoiceArg<"googleDriveIntegration">;
  className?: string;
}

function PlasmicNoteViewer__RenderFunc(props: {
  variants: PlasmicNoteViewer__VariantsArgs;
  args: PlasmicNoteViewer__ArgsType;
  overrides: PlasmicNoteViewer__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__hukz4, {
          [sty.freeBoxnotionIntegration__hukz4QdQf6]: hasVariant(
            variants,
            "notionIntegration",
            "notionIntegration"
          )
        })}
      >
        <div className={classNames(projectcss.all, sty.freeBox__lMBzM)}>
          <div className={classNames(projectcss.all, sty.freeBox___0BKrP)}>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__crVg2, {
                [sty.freeBoxgoogleDriveIntegration__crVg2VwNFs]: hasVariant(
                  variants,
                  "googleDriveIntegration",
                  "googleDriveIntegration"
                )
              })}
            >
              <p.Stack
                as={"div"}
                data-plasmic-name={"closeHandle"}
                data-plasmic-override={overrides.closeHandle}
                hasGap={true}
                className={classNames(projectcss.all, sty.closeHandle)}
              >
                <FastArrowDownSvgrepoComsvgIcon
                  data-plasmic-name={"svg"}
                  data-plasmic-override={overrides.svg}
                  className={classNames(projectcss.all, sty.svg)}
                  role={"img"}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lpHpy
                  )}
                >
                  {"Save & Close"}
                </div>
              </p.Stack>

              {(hasVariant(variants, "justView", "justView") ? true : true) ? (
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__kEnuo, {
                    [sty.freeBoxgoogleDriveIntegration__kEnuoVwNFs]: hasVariant(
                      variants,
                      "googleDriveIntegration",
                      "googleDriveIntegration"
                    ),
                    [sty.freeBoxjustView__kEnuomQC]: hasVariant(
                      variants,
                      "justView",
                      "justView"
                    )
                  })}
                >
                  {true ? (
                    <Textarea
                      data-plasmic-name={"noteLink"}
                      data-plasmic-override={overrides.noteLink}
                      className={classNames("__wab_instance", sty.noteLink)}
                      disabled={true}
                    />
                  ) : null}

                  <DownloadSvgrepoComsvgIcon
                    data-plasmic-name={"downloadButton"}
                    data-plasmic-override={overrides.downloadButton}
                    className={classNames(projectcss.all, sty.downloadButton)}
                    role={"img"}
                  />

                  <CopySvgrepoComsvgIcon
                    data-plasmic-name={"copyNoteLink"}
                    data-plasmic-override={overrides.copyNoteLink}
                    className={classNames(projectcss.all, sty.copyNoteLink)}
                    role={"img"}
                  />
                </p.Stack>
              ) : null}
            </p.Stack>

            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__erafc)}
            />
          </div>

          <div
            className={classNames(projectcss.all, sty.freeBox__fFmAy, {
              [sty.freeBoxgoogleDriveIntegration__fFmAyVwNFs]: hasVariant(
                variants,
                "googleDriveIntegration",
                "googleDriveIntegration"
              ),
              [sty.freeBoxnotionIntegration__fFmAyqdQf6]: hasVariant(
                variants,
                "notionIntegration",
                "notionIntegration"
              )
            })}
          >
            {(
              hasVariant(
                variants,
                "googleDriveIntegration",
                "googleDriveIntegration"
              )
                ? true
                : hasVariant(variants, "notionIntegration", "notionIntegration")
                ? true
                : true
            ) ? (
              <div
                className={classNames(projectcss.all, sty.freeBox__ulYgn, {
                  [sty.freeBoxgoogleDriveIntegration__ulYgnVwNFs]: hasVariant(
                    variants,
                    "googleDriveIntegration",
                    "googleDriveIntegration"
                  ),
                  [sty.freeBoxnotionIntegration__ulYgnqdQf6]: hasVariant(
                    variants,
                    "notionIntegration",
                    "notionIntegration"
                  )
                })}
              >
                {(
                  hasVariant(
                    variants,
                    "googleDriveIntegration",
                    "googleDriveIntegration"
                  )
                    ? true
                    : hasVariant(
                        variants,
                        "notionIntegration",
                        "notionIntegration"
                      )
                    ? true
                    : true
                ) ? (
                  <div
                    data-plasmic-name={"columns"}
                    data-plasmic-override={overrides.columns}
                    className={classNames(projectcss.all, sty.columns, {
                      [sty.columnsgoogleDriveIntegration]: hasVariant(
                        variants,
                        "googleDriveIntegration",
                        "googleDriveIntegration"
                      ),
                      [sty.columnsnotionIntegration]: hasVariant(
                        variants,
                        "notionIntegration",
                        "notionIntegration"
                      )
                    })}
                  >
                    {(
                      hasVariant(
                        variants,
                        "notionIntegration",
                        "notionIntegration"
                      )
                        ? true
                        : true
                    ) ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.column___4CpC,
                          {
                            [sty.columnnotionIntegration___4CpCqdQf6]:
                              hasVariant(
                                variants,
                                "notionIntegration",
                                "notionIntegration"
                              )
                          }
                        )}
                      >
                        {(
                          hasVariant(
                            variants,
                            "notionIntegration",
                            "notionIntegration"
                          )
                            ? true
                            : true
                        ) ? (
                          <p.PlasmicImg
                            data-plasmic-name={"img"}
                            data-plasmic-override={overrides.img}
                            alt={""}
                            className={classNames(sty.img, {
                              [sty.imgnotionIntegration]: hasVariant(
                                variants,
                                "notionIntegration",
                                "notionIntegration"
                              )
                            })}
                            displayHeight={"auto" as const}
                            displayMaxHeight={"none" as const}
                            displayMaxWidth={"100%" as const}
                            displayMinHeight={"0" as const}
                            displayMinWidth={"0" as const}
                            displayWidth={"auto" as const}
                            loading={"lazy" as const}
                            src={{
                              src: image2EMd0CwY,
                              fullWidth: 512,
                              fullHeight: 512,
                              aspectRatio: undefined
                            }}
                          />
                        ) : null}
                      </div>
                    ) : null}
                    {(
                      hasVariant(
                        variants,
                        "notionIntegration",
                        "notionIntegration"
                      )
                        ? true
                        : true
                    ) ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.column___8IyJn,
                          {
                            [sty.columnnotionIntegration___8IyJnqdQf6]:
                              hasVariant(
                                variants,
                                "notionIntegration",
                                "notionIntegration"
                              )
                          }
                        )}
                      >
                        <Button
                          data-plasmic-name={"notionButton"}
                          data-plasmic-override={overrides.notionButton}
                          className={classNames(
                            "__wab_instance",
                            sty.notionButton,
                            {
                              [sty.notionButtonnotionIntegration]: hasVariant(
                                variants,
                                "notionIntegration",
                                "notionIntegration"
                              )
                            }
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__sD3Z7
                            )}
                          >
                            {"Open linked Notion page"}
                          </div>
                        </Button>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}

            <div
              data-plasmic-name={"editor"}
              data-plasmic-override={overrides.editor}
              className={classNames(projectcss.all, sty.editor, {
                [sty.editorgoogleDriveIntegration]: hasVariant(
                  variants,
                  "googleDriveIntegration",
                  "googleDriveIntegration"
                ),
                [sty.editorjustView]: hasVariant(
                  variants,
                  "justView",
                  "justView"
                )
              })}
            />

            {(
              hasVariant(
                variants,
                "googleDriveIntegration",
                "googleDriveIntegration"
              )
                ? true
                : true
            ) ? (
              <DrivePlugin
                data-plasmic-name={"drivePlugin"}
                data-plasmic-override={overrides.drivePlugin}
                className={classNames("__wab_instance", sty.drivePlugin, {
                  [sty.drivePlugingoogleDriveIntegration]: hasVariant(
                    variants,
                    "googleDriveIntegration",
                    "googleDriveIntegration"
                  )
                })}
              />
            ) : null}
          </div>

          {(hasVariant(variants, "justView", "justView") ? true : true) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__r3PYu, {
                [sty.freeBoxjustView__r3PYUmQC]: hasVariant(
                  variants,
                  "justView",
                  "justView"
                ),
                [sty.freeBoxnotionIntegration__r3PYUqdQf6]: hasVariant(
                  variants,
                  "notionIntegration",
                  "notionIntegration"
                )
              })}
            >
              <div className={classNames(projectcss.all, sty.freeBox__ielCf)}>
                <Button
                  data-plasmic-name={"deleteButton"}
                  data-plasmic-override={overrides.deleteButton}
                  className={classNames("__wab_instance", sty.deleteButton, {
                    [sty.deleteButtonjustView]: hasVariant(
                      variants,
                      "justView",
                      "justView"
                    )
                  })}
                  color={"softRed" as const}
                  size={"compact" as const}
                >
                  {"Delete"}
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "closeHandle",
    "svg",
    "noteLink",
    "downloadButton",
    "copyNoteLink",
    "columns",
    "img",
    "notionButton",
    "editor",
    "drivePlugin",
    "deleteButton"
  ],
  closeHandle: ["closeHandle", "svg"],
  svg: ["svg"],
  noteLink: ["noteLink"],
  downloadButton: ["downloadButton"],
  copyNoteLink: ["copyNoteLink"],
  columns: ["columns", "img", "notionButton"],
  img: ["img"],
  notionButton: ["notionButton"],
  editor: ["editor"],
  drivePlugin: ["drivePlugin"],
  deleteButton: ["deleteButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  closeHandle: "div";
  svg: "svg";
  noteLink: typeof Textarea;
  downloadButton: "svg";
  copyNoteLink: "svg";
  columns: "div";
  img: typeof p.PlasmicImg;
  notionButton: typeof Button;
  editor: "div";
  drivePlugin: typeof DrivePlugin;
  deleteButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNoteViewer__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNoteViewer__VariantsArgs;
    args?: PlasmicNoteViewer__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicNoteViewer__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicNoteViewer__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicNoteViewer__ArgProps,
          internalVariantPropNames: PlasmicNoteViewer__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicNoteViewer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNoteViewer";
  } else {
    func.displayName = `PlasmicNoteViewer.${nodeName}`;
  }
  return func;
}

export const PlasmicNoteViewer = Object.assign(
  // Top-level PlasmicNoteViewer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeHandle: makeNodeComponent("closeHandle"),
    svg: makeNodeComponent("svg"),
    noteLink: makeNodeComponent("noteLink"),
    downloadButton: makeNodeComponent("downloadButton"),
    copyNoteLink: makeNodeComponent("copyNoteLink"),
    columns: makeNodeComponent("columns"),
    img: makeNodeComponent("img"),
    notionButton: makeNodeComponent("notionButton"),
    editor: makeNodeComponent("editor"),
    drivePlugin: makeNodeComponent("drivePlugin"),
    deleteButton: makeNodeComponent("deleteButton"),

    // Metadata about props expected for PlasmicNoteViewer
    internalVariantProps: PlasmicNoteViewer__VariantProps,
    internalArgProps: PlasmicNoteViewer__ArgProps
  }
);

export default PlasmicNoteViewer;
/* prettier-ignore-end */
